export default [
  {
    path: '/active-gkjxjjh/index',
    name: 'index',
    component: () => import('@/views/active-gkjxjjh/index'),
    meta: {
      title: '2021高考直通车奖学金计划'
    }
  },
  {
    path: '/active-gkjxjjh/myrecord',
    name: 'index',
    component: () => import('@/views/active-gkjxjjh/myrecord'),
    meta: {
      title: '我的记录-2021高考直通车奖学金计划'
    }
  },
  {
    path: '/active-gkjxjjh/invite',
    name: 'index',
    component: () => import('@/views/active-gkjxjjh/invite'),
    meta: {
      title: '邀请你来参与高考直通车奖学金计划'
    }
  }
]
